(function () {

  function clearProductInputs() {
    // 清空尺寸
    const widthInput = document.querySelector('.calc-field[data-name="width"] input');
    const heightInput = document.querySelector('.calc-field[data-name="height"] input');

    if (widthInput) widthInput.value = '';
    if (heightInput) heightInput.value = '';

    // 清空文件上传
    document.querySelectorAll('input[type="file"]').forEach(input => {
  if (!input.closest('[id*="upload"]') && !input.closest('[data-upload-lift]')) {
    input.value = '';
  }
});


    // 如果你 artwork-size-check 里用了全局标记，也可以顺手清掉
    if (window.__artworkSizeCheckerInstalled && window.lastCheck) {
      try { window.lastCheck.clear(); } catch (e) {}
    }
  }

  // 监听 Add to Cart 成功（fetch 方式）
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    setTimeout(() => {
      clearProductInputs();
    }, 1200); // 给 Shopify AJAX 一点时间
  });

})();
